import './App.css';
import NavBar from './Components/NavBar'
import Hero from './Components/Hero'
import About from './Components/About'
import Contact from './Components/Contact'
import Footer from './Components/Footer'
import { AuthProvider } from './Context/AuthContext';
import { useState } from 'react';
import Login from './Components/Login';


function App() {
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const toggleLoginModal = () => {
    setIsLoginOpen(!isLoginOpen);
  };

  return (
    <AuthProvider>
      <div className='bg-gradient-to-b from-black via-purple-950/60 to-black min-h-screen'>
        <NavBar onLoginClick={toggleLoginModal} />
        <Hero onLoginClick={toggleLoginModal} />
        <About />
        <Contact />
        <Footer />
      </div>
      {isLoginOpen && <Login onClose={toggleLoginModal} />}
    </AuthProvider>
  );
}

export default App;
